import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { useContext, useState } from 'react';
import { AppContext } from '../stores/app.store';
import { ArtistName } from './artist-name.component';

export const ArtistSlider = observer(() => {
    const { auctionStore } = useContext(AppContext);
    const data = auctionStore.auctionData;
    const artist = data?.artistPublic;
    const displayName = data?.artistPublic?.pseudonym || `${data?.artistPublic?.firstName} ${data?.artistPublic?.lastName}`;

    const [isToggled, setIsToggled] = useState(false);
    const [maxHeight, setMaxHeight] = useState('0');

    const mouseActions = {
        onMouseEnter: () => setMaxHeight('400px'),
        onMouseLeave: () => setMaxHeight('0'),
    };

    return (
        <div>
            <div className={`mx-4 t-250 ${isToggled ? 'slide-up' : ''}`} >
                <div className="hover-highlight cursor-pointer" onClick={() => setIsToggled(true)}>
                    <ArtistName className="text-300 text-shadow" {...artist} />
                </div>
                <h2 className="text-uppercase opacity-50 text-shadow text-avenir-db" {...mouseActions}>{data?.title}</h2>
                <div style={{ maxHeight }} className="col-9 mt-2 t-250 overflow-hidden">
                    <p className="text-avenir-re text-shadow text-115">
                        <span>{data?.nftTokenId}</span>
                        <span>{data?.description}</span>
                    </p>
                </div>
                <div style={{ height: '5px', width: '100px' }} className="bg-light"></div>
            </div>
            <div style={{ transform: 'translateY(-150%)' }} className={`position-absolute top-0 t-250 delay-3 ${isToggled ? 'slide-0' : ''}`}>
                <div className="bg-darker p-4">
                    <div className="d-flex justify-content-center align-items-center">
                        <img width={80} height={80} className="rounded-circle img-cover" src={artist?.images.thumbnail.data} alt={displayName} />
                        <div className="ms-3">
                            <ArtistName style={{ fontSize: '240%', marginBottom: '-10px' }} {...artist} />
                            <a target="_blank" href={artist?.website} rel="noreferrer">{artist?.website}</a>
                        </div>
                    </div>
                    <div>
                        <hr className="mb-3" />
                        <div className="text-avenir-re text-muted text-115">{artist?.bio}</div>
                        <div className="text-center">
                            <button type="button" className="w-100 btn btn-transparent text-light hover-highlight" onClick={() => setIsToggled(false)}>
                                <FontAwesomeIcon icon="chevron-up" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});